<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 7.83325H3.33333C2.59695 7.83325 2 8.43021 2 9.16659V13.8333C2 14.5696 2.59695 15.1666 3.33333 15.1666H12.6667C13.403 15.1666 14 14.5696 14 13.8333V9.16659C14 8.43021 13.403 7.83325 12.6667 7.83325Z"
      stroke="#FF8A71"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.66663 7.83325V5.16659C4.66663 4.28253 5.01782 3.43468 5.64294 2.80956C6.26806 2.18444 7.1159 1.83325 7.99996 1.83325C8.88401 1.83325 9.73186 2.18444 10.357 2.80956C10.9821 3.43468 11.3333 4.28253 11.3333 5.16659V7.83325"
      stroke="#FF8A71"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
